<template>
    <div class="row" v-show="aFeaturedAccess.length > 0">
        <div class="col-12">
            <div v-if="!isMobile" class="box-shadow-light bt-0 mt-m1 featured-access-container" :style="{ 'background-color': backgroundColor, 'border-top-color': backgroundColor }">
                <div class="featured-access-group text-center"
                     v-for="(access, index) in aFeaturedAccess"
                     :class="[ access.url ? 'cursor-pointer' : '' ]"
                     :key="'fa_' + index"
                     @click="openFeaturedAccessUrl(access)">
                    <div :class="[ access.title ? 'featured-access-img-title' : 'featured-access-img-no-title' ]">
                        <img class="featured-access-img" :src="access.path" :alt="access.file_name">
                    </div>

                    <span v-if="access.title" :style="{ color: access.title_color }">{{ access.title }}</span>
                </div>
            </div>
            <div v-else class="box-shadow-light bt-0 mt-m1 featured-access-container mobile-fa" :style="{ 'background-color': backgroundColor, 'border-top-color': backgroundColor }">
                <carousel :autoplay="false"
                          :dots="true"
                          :items="2"
                          :loop="false"
                          :margin="10"
                          :nav="false"
                          v-if="!isLoadingData">

                    <div class="gallery-item" v-for="(item, index) in aFeaturedAccess"
                                              :key="'fa_' + index"
                                              @click="openFeaturedAccessUrl(item)">
                        <div class="gallery-item-image-container">
                            <img class="gallery-item-image" :src="item.path" :alt="item.file_name">
                        </div>
                        <div class="gallery-item-details">
                            <span class="fa-gallery-item-name fs-20" :style="{ color: item.title_color }">{{ item.title }}</span>
                        </div>
                    </div>
                </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import Carousel from 'vue-owl-carousel';
import fileRootPathMixin from '../../../mixins/fileRootPathMixin';

export default {

    components: {

        Carousel,

    },

    mixins: [

        fileRootPathMixin,

    ],

    data() {

        return {

            isLoadingData: true,

            backgroundColor: '#dcdcdc',

            aFeaturedAccess: [],

        };

    },

    mounted() {

        this.loadBackgroundColor();

        this.loadFeaturedAccess();

    },

    methods: {

        loadBackgroundColor() {

            const backgroundColor = localStorage.getItem('featured_access_bg_color');

            if (backgroundColor) {

                this.backgroundColor = backgroundColor;

            }

        },

        loadFeaturedAccess() {

            const featuredAccess = $.parseJSON(localStorage.getItem('featured_access'));

            if (featuredAccess && featuredAccess.length > 0) {

                this.aFeaturedAccess = featuredAccess.map((access) => {

                    access.path = this.fileRootPath + access.path;

                    return access;

                });

                this.isLoadingData = false;

            }

        },

        openFeaturedAccessUrl({ url, opening_type = '_self' }) {

            if (url) {

                window.open(url, opening_type);

            }

        },

    },

};
</script>
